import { NetworkSettings } from "../../../config/NetworkSettings";
import { Service } from "../../../core/impl/Service";
import { NetworkInstance } from "../model/NetworkInstance";
import { parseNetworkSettings, parseInstances, parseTestInstances } from "../parser/NetworkXMLParser";
import { Context } from "../../../core/impl/Context";
import { NetworkInstancesManager } from "../manager/NetworkInstancesManager";
import { getLogger } from "@goodgamestudios/logger";
import { WorldAssignmentTrackingConstants } from "../../../TrackingConstants";
import { WorldAssignmentError } from "../../../error/WorldAssignmentError";
import { WorldAssignmentErrorCodes } from "../../../error/WorldAssignmentErrorCodes";

const logger = getLogger("WorldAssignment.NetworkInstancesController");


export const loadNetworkInstances = async (trackingCallback?: (state: string) => void) => {
    logger.debug("loadNetworkInstances: load network.xml");
    if (trackingCallback) {
        trackingCallback(WorldAssignmentTrackingConstants.NETWORK_XML_START);
    }
    const service = new Service(Context.instance.globals.networkConfigUrl);
    return service.load()
        .then((payload) => {
            if (trackingCallback) {
                trackingCallback(WorldAssignmentTrackingConstants.NETWORK_XML_END);
            }
            const { settings, instances } = onNetworkInstancesLoaded(payload, Context.instance.globals.isTestEnvironment || Context.instance.globals.forceToShowTestServers);
            Context.instance.set(settings);
            Context.instance.get(NetworkInstancesManager).initializeInstances(instances);
            logger.debug("loadNetworkInstances Completed");
            return instances;
        })
        .catch(() => {
            throw new WorldAssignmentError(
                WorldAssignmentErrorCodes.NETWORK_FAILED_TO_LOAD,
                "Failed to load network.xml from " + Context.instance.globals.networkConfigUrl
            );
        });
}


const onNetworkInstancesLoaded = (payload: any, includeTestInstances: boolean = false): { settings: NetworkSettings, instances: NetworkInstance[] } => {
    const instances: NetworkInstance[] = parseInstances(payload);
    return {
        settings: parseNetworkSettings(payload),
        instances: includeTestInstances ? [...instances, ...parseTestInstances(payload)] : instances
    }
}
